import { Box, Typography } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import DownloadFileFromComponent from 'src/components/ui-component/form-component/form-fields/fields/DownloadFileFromComponent';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { FOERDERPROGRAMM_DATEIEN_JE_MA_PATHS } from 'src/lib/constants/componentsPath';

// import Schemas
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
const P = MittelabrufSchema.attributes;

const DownloadsMA: FC<{}> = () => {
	const { application } = useApplication();

	// Daten für ProgrammSpezifischDateien
	const foerderprogramm = get(application, P.Foerderantrag.schema.attributes.Foerderprogramm.path, {});
	// Pfade für programm spezifische Dateien basierend auf AntragsTyp
	const paths = FOERDERPROGRAMM_DATEIEN_JE_MA_PATHS;

	const programmSpezifischInhalt = get(foerderprogramm, paths.Inhalt, '');
	const programmSpezifischDateien = get(foerderprogramm, paths.DateienBlock, '');

	// Prüfen ob mindestens ein Element ein Titel hat
	const hasProgrammSpezifischTitel = isArray(programmSpezifischDateien) && programmSpezifischDateien.some((item: any) => item?.Titel);

	return (
		<>
			{/**Aus Förderprogramm */}
			<ProgrammSpezifischDateien
				programmSpezifischInhalt={programmSpezifischInhalt}
				programmSpezifischDateien={programmSpezifischDateien}
				hasTitel={hasProgrammSpezifischTitel}
			/>
		</>
	);
};

export default DownloadsMA;

const ProgrammSpezifischDateien: FC<{ programmSpezifischInhalt: string; programmSpezifischDateien: any[]; hasTitel: boolean }> = ({
	programmSpezifischInhalt,
	programmSpezifischDateien,
	hasTitel,
}) => {
	console.log('hasTitel', hasTitel);
	console.log('programmSpezifischInhalt', programmSpezifischInhalt);
	if (hasTitel || programmSpezifischInhalt) {
		console.log('hasTitel || programmSpezifischInhalt', hasTitel || programmSpezifischInhalt);
		return (
			<>
				<Box sx={{ mt: '1rem' }}>
					<Typography variant='h3' component={'h3'}>
						Downloads
					</Typography>
					<MarkdownRenderer markdown={programmSpezifischInhalt} />
					<DownloadFileFromComponent component={programmSpezifischDateien} filePathInComponent='Datei' />
				</Box>
			</>
		);
	}

	return <></>;
};
